import React from "react";
import { useController } from "react-hook-form";

export function Checkbox(props) {
  const { label, name, control, onChange, checked } = props;
  const { field } = useController({
    name,
    control,
  });

  return (
    <div className="relative flex items-start">
      <div className="flex h-6 items-center">
        <input
          id={field.name}
          name={field.name}
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-blue focus:ring-blue"
          onChange={onChange}
          checked={checked}
        />
      </div>
      <div className="ml-3 font-light text-gray-900 text-sm leading-6">
        <label htmlFor={field.name}>{label}</label>
      </div>
    </div>
  );
}

export function CheckboxGroup({ name, control, options, isGrouped = false, onChange }) {
  const { field } = useController({
    name,
    control,
    defaultValue: [],
  });

  const handleCheckboxChange = (optionValue, checked) => {
    if (onChange) {
      onChange(optionValue, checked);
    } else {
      const newValue = field.value.includes(optionValue)
        ? field.value.filter((value) => value !== optionValue)
        : [...field.value, optionValue];
      field.onChange(newValue);
    }
  };

  const renderCheckboxes = (options) => {
    return options.map((option) => (
      <div key={option.value} className="py-2">
        <Checkbox
          label={option.label}
          name={`${name}.${option.value}`}
          control={control}
          checked={field.value.includes(option.value)}
          onChange={(e) => handleCheckboxChange(option.value, e.target.checked)}
        />
      </div>
    ));
  };

  if (isGrouped) {
    return (
      <div className="space-y-4">
        {options.map((group) => (
          <div
            key={group.label}
            className="p-3 bg-gray-50 rounded-lg border border-gray-100 shadow-sm"
          >
            <h4 className="text-sm font-semibold text-gray-700 mb-2">{group.label}</h4>
            <div className="space-y-2">{renderCheckboxes(group.options)}</div>
          </div>
        ))}
      </div>
    );
  }

  return <div>{renderCheckboxes(options)}</div>;
}